import { useIsFocused } from '@react-navigation/native';
import { useStoreContext } from 'features/store';
import { useIntl } from 'react-intl';
import { freezeEnabled } from 'react-native-screens';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { LocationEmptyState } from 'components/location-empty-state';
import { LoyaltyOffersBase } from 'pages/loyalty/loyalty-offers/loyalty-offers-base';
import { LoyaltyOffersCooldownMessage } from 'pages/loyalty/loyalty-offers/loyalty-offers-cooldown-message';
import { isWeb } from 'utils/environment';

export default function OffersScreen() {
  const { noStoreSelected } = useStoreContext();
  const { formatMessage } = useIntl();

  /**
   * IMPORTANT: Do not remove this code or offers will have issues in cart on web!
   *
   * Why this is needed:
   * - On web, components remain mounted when navigating between tabs (unlike native
   *   where they are "frozen" with react-native-screens).
   * - This means renders can occur here when on other pages only on web.
   * - The useReduceOffers hook (used nested here) has a side effect that causes the
   *   cart to not load properly if it's running simultaneously with the one in cart.
   *
   * TODO: Refactor useReduceOffers or move to backend
   *
   * The freezeEnabled check handles the case where screen freezing might be
   * disabled in the future, which would cause this bug to appear on native too.
   */
  if (isWeb || !freezeEnabled()) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isFocused = useIsFocused();
    if (!isFocused) {
      return null;
    }
  }

  if (noStoreSelected) {
    return (
      <LocationEmptyState
        title={formatMessage({ id: 'emptyOffersHeading' })}
        message={formatMessage({ id: 'emptyMenuMessage' })}
      />
    );
  }
  return (
    <>
      <LoyaltyOffersBase />
      <LoyaltyOffersCooldownMessage />
      <FloatingViewCartFab />
    </>
  );
}
